const uuidv4 = require("uuid/v4");

export const state = {
  popups: [],
};

// getters
export const getters = {
  popups: (state) => state.popups,
};

// mutations
export const mutations = {
  addPopup: (state, value) => {
    state.popups.push(value);
    return state.popups;
  },
  deletePopup: (state, value) => {
    state.popups = state.popups.filter((e) => e.id !== value);
    return state.popups;
  },
};

// actions
export const actions = {
  /**
   * Set the person store
   * @param {*} param0
   * @param {*} payload
   */
  addPopup({ commit, dispatch }, payload) {
    if (!payload.id) {
      payload.id = uuidv4();
    }
    commit("addPopup", payload);
  },
  deletePopup({ commit, dispatch }, id) {
    if (id !== null || id !== undefined) {
      commit("deletePopup", id);
    }
  },
};
